import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=3bdd1924&"
import script from "./TableOfContents.vue?vue&type=script&lang=js&"
export * from "./TableOfContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports